import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { EMPTY } from 'rxjs';
import { switchMap, withLatestFrom } from 'rxjs/operators';
import { GeneralNotifications } from '../../../shared/models/notification/notification.model';
import { WSStatus } from '../../../shared/models/message/message.model';
import { IAppState } from '../../index';
import * as NotificationActions from '../actions/notification.action';
import { NotificationService } from '../services/notification.service';

@Injectable()
export class NotificationEffects {
    setGeneralNotifications$ = createEffect(() => this.actions$
      .pipe(
        ofType(NotificationActions.setGeneral),
        withLatestFrom(this.store),
        switchMap(([action, state]) => {
          const isSuccessful = action.payload.status !== WSStatus.ERROR;

          if (isSuccessful) {
            const notifications = action.payload.data as GeneralNotifications;

            return [
              NotificationActions.changed({
                total: notifications,
                errors: [],
              })
            ];
          } else {
            return EMPTY;
          }
        })));

    readNotification$ = createEffect(() => this.actions$
      .pipe(
        ofType(NotificationActions.readNotification),
        switchMap((action) => {
          this.notificationService.readNotifications(
            action.message,
            action.sender,
            action.channel
          );

          return [NotificationActions.readNotificationSuccess()];
        })));

    constructor(
      private actions$: Actions,
      private notificationService: NotificationService,
      private store: Store<IAppState>
    ) { }
}
